exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-control[data-v-2ecdee7e] {\n  height: 42px;\n  border-radius: 4px;\n}\n.add-fabric tbody > tr > td[data-v-2ecdee7e] {\n  vertical-align: top;\n}\n.btn[data-v-2ecdee7e] {\n  height: 42px;\n}\n.table[data-v-2ecdee7e] {\n  margin-bottom: 0px;\n}\n.add-fabric-div[data-v-2ecdee7e] {\n  position: sticky;\n  top: 60px;\n  background: white;\n  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);\n  z-index: 99;\n}\n", ""]);

// exports
